import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import HorizontalRule from 'components/HorizontalRule';
import { getMarketplaceStats } from 'redux/ducks/Dashboard';
import './MarketplaceStatsModal.scss';

const formatRate = (rate) => (rate === null || rate === undefined ? '—' : `$${Number(rate).toFixed(2)}`);

class MarketplaceStatsModal extends Component {
  state = { zipInput: '' };

  _debounceTimer = null;

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({ zipInput: this.props.marketplaceStats.currentZip || '' });
    }
  }

  componentWillUnmount() {
    clearTimeout(this._debounceTimer);
  }

  onZipChange = (e) => {
    const zip = e.target.value;
    this.setState({ zipInput: zip });

    clearTimeout(this._debounceTimer);
    if (zip.length === 5 && /^\d{5}$/.test(zip)) {
      this._debounceTimer = setTimeout(() => {
        this.props.getMarketplaceStats(zip);
      }, 500);
    }
  };

  render() {
    const { isOpen, onClose, marketplaceStats, user } = this.props;
    const { zipInput } = this.state;
    const { atsWithin50Miles, avgTransactedRate, loading, zipError, currentZip } = marketplaceStats;

    const displayZip = currentZip || user.addressZip || '';
    const stateAbbr = displayZip ? '(your area)' : '';

    return (
      <Modal isOpen={isOpen} toggle={onClose} className="marketplace-stats-modal">
        <ModalHeader className="header" toggle={onClose}>Change Zip Code</ModalHeader>
        <ModalBody>
          <div className="msm-stats-row">
            <div className="msm-stat">
              <span className="msm-stat-value">
                {loading ? '—' : (atsWithin50Miles ?? '—')}
              </span>
              <span className="msm-stat-label">
                verified ATs within 50 miles of {displayZip || 'your zip'}
              </span>
            </div>
            <div className="msm-stat">
              <span className="msm-stat-value">
                {loading ? '—' : formatRate(avgTransactedRate)}
              </span>
              <span className="msm-stat-label">avg transacted rate {stateAbbr}</span>
            </div>
          </div>

          <HorizontalRule dashed margin="16px" />

          <div className="msm-zip-control">
            <label className="msm-label" htmlFor="msm-zip-input">
              Search a different zip code
            </label>
            <input
              id="msm-zip-input"
              type="text"
              className={`msm-input form-control${zipError ? ' is-invalid' : ''}`}
              value={zipInput}
              onChange={this.onZipChange}
              placeholder="Enter 5-digit zip"
              maxLength={5}
            />
            {zipError && (
              <div className="invalid-feedback">{zipError}</div>
            )}
            <p className="msm-hint">
              Results update automatically as you type.
            </p>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  marketplaceStats: state.dashboard.marketplaceStats,
  user: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  getMarketplaceStats: (zip) => dispatch(getMarketplaceStats(zip)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MarketplaceStatsModal);
